module.exports = __webpack_public_path__ + "img/xls.793d67fd.svg";